var map = {
	"./artificialIntelligence.json": 943,
	"./becomingRich.json": 949,
	"./bookReview.json": 385,
	"./chatGPT.json": 206,
	"./climateChange.json": 530,
	"./confidence.json": 162,
	"./coronavirus.json": 297,
	"./crispr.json": 732,
	"./datingAdvice.json": 168,
	"./elonMusk.json": 904,
	"./exoplanets.json": 183,
	"./geopolitics.json": 57,
	"./happiness.json": 823,
	"./healthySleep.json": 83,
	"./investing.json": 895,
	"./jobInterview.json": 927,
	"./kobeBryant.json": 513,
	"./lucidDreaming.json": 128,
	"./magicTricks.json": 782,
	"./makePeopleLikeYou.json": 97,
	"./math.json": 149,
	"./meditation.json": 752,
	"./motivation.json": 859,
	"./positiveThinking.json": 819,
	"./programmingLanguages.json": 987,
	"./relievingCough.json": 963,
	"./returnToTheMoon.json": 753,
	"./selfLove.json": 80,
	"./spaceExploration.json": 584,
	"./startups.json": 839,
	"./studyEfficiently.json": 916,
	"./ukraineWar.json": 167
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 799;